import React, {useState} from "react";
import {TextField} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import {useSelector} from "react-redux";
import I18nInputAdornmentSelect from "../i18n-input-adornment-select";
import {languageSelector, languagesSelector} from "../../state/app/appSelectors";

const I18nTextField = textFieldProps => {
  const languages = useSelector(languagesSelector);
  const defaultLanguage = useSelector(languageSelector);

  const [language, setLanguage] = useState(defaultLanguage);

  return (
    <TextField
      {...textFieldProps}
      value={textFieldProps.value && textFieldProps.value[language] ? textFieldProps.value[language] : ""}
      onChange={({target}) => {
        const res = {};
        languages.forEach(lang => {
          if (textFieldProps.value && textFieldProps.value[lang]) {
            res[lang] = textFieldProps.value[lang];
          }
        });
        res[language] = target.value;
        textFieldProps.onChange(res);
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <I18nInputAdornmentSelect value={language} onChange={lang => setLanguage(lang)} />
          </InputAdornment>
        )
      }}
    >
      {textFieldProps.children}
    </TextField>
  );
};

export default I18nTextField;
